  /**
   * Author: Neeti
   * Project: Ludo Board Game
   * Copyright: Moblize.IT LLC | All rights reserved
   * Last Modified: May 24 2020
   * 
   * Description: Core module file for app level dependencies and config
   * 
   */
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from "@angular/fire/auth";
import { EatPizzaComponent } from './eat-pizza/eat-pizza.component';

const firebaseConfig = {
  apiKey: "AIzaSyA84TPIi6f0cjUj5KJOqX6udqvEf0VmExQ",
  authDomain: "ludo-mit.firebaseapp.com",
  databaseURL: "https://ludo-mit.firebaseio.com",
  projectId: "ludo-mit",
  storageBucket: "ludo-mit.appspot.com",
  messagingSenderId: "826794010773",
  appId: "1:826794010773:web:c846f417cf5c00c784939c",
  measurementId: "G-WNXGKC0FV4"
};


@NgModule({
  declarations: [
    AppComponent,
    EatPizzaComponent
  ],
  entryComponents: [
    EatPizzaComponent
  ],
  imports: [
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
